import React from 'react';

interface GameHUDProps {
  hearts: number;
  score: number;
  streak: number;
  activeMultiplier: number;
  currentQuestion: number;
  totalQuestions: number;
  scoreAnimating: boolean;
}

const GameHUD: React.FC<GameHUDProps> = ({
  hearts,
  score,
  streak,
  activeMultiplier,
  currentQuestion,
  totalQuestions,
  scoreAnimating,
}) => {
  return (
    <div className="game-hud">
      <div className="hud-left">
        <div className="hud-hearts">
          {Array.from({ length: hearts }, (_, i) => (
            <span key={i} className="heart">&#10084;&#65039;</span>
          ))}
        </div>
        <span className="hud-question-count">
          Q{currentQuestion + 1}/{totalQuestions}
        </span>
      </div>
      <div className="hud-center">
        <span className={`hud-score ${scoreAnimating ? 'score-animate' : ''}`}>
          {score.toLocaleString()} pts
        </span>
      </div>
      <div className="hud-right">
        {streak > 0 && (
          <span className={`hud-streak ${streak >= 5 ? 'fire-glow' : ''}`}>
            &#128293; {streak}
          </span>
        )}
        {activeMultiplier > 1 && (
          <span className="hud-multiplier-badge">{activeMultiplier.toFixed(1)}x</span>
        )}
      </div>
    </div>
  );
};

export default GameHUD;
